module.exports = __webpack_public_path__ + "static/media/value_prop_device@2x.f5b063c7.png";